var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticStyle:{"z-index":"1000"},attrs:{"color":"primary","opacity":"1"}},[_c('Loading',{attrs:{"text":"Logging out ...","progress_color":"white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }